export default __webpack_public_path__ + "static/media/GraftCafe-3.12a5111e.jpg";